<template>
  <div>
    <div class=" m-2">
      <div class="flex flex-wrap justify-around ">
        <ClassicButton
          v-for="color in config"
          :key="color"
          classButton="rounded-full "
          type="button"
          flexOption=""
          @buttonClick.prevent="
            selectedColor = color;
            $emit('selectColor', color);
          "
        >
          <template v-slot:ButtonContent>
            <ColorRound :color="'text-' + color + '-600'" />
          </template>
        </ClassicButton>
      </div>
    </div>
  </div>
</template>

<script>
import Config from "@/components/ui/config";
import ColorRound from "@/components/ui/generic/fragments/ColorRound.vue";
import ClassicButton from "@/components/ui/form/button/ClassicButton.vue";

export default {
  props: {},
  data() {
    return {
      selectedColor: "gray",
      config: Config.SKOR_COLORS
    };
  },
  components: {
    ColorRound,
    ClassicButton
  }
};
</script>
